// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3ANHT","footer":"Form_footer__wzOwS"};